import { render, staticRenderFns } from "./vehicleProcurement.vue?vue&type=template&id=80318cce&scoped=true"
import script from "./vehicleProcurement.vue?vue&type=script&lang=js"
export * from "./vehicleProcurement.vue?vue&type=script&lang=js"
import style0 from "./vehicleProcurement.vue?vue&type=style&index=0&id=80318cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80318cce",
  null
  
)

export default component.exports